// @flow
import * as React from "react";
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import * as actions from "./modules/actions";
import positions from "./helpers/positions";

import { Header, Footer } from './components';
import { SSO } from "./components/utils/SSO";
import PrivateRoute from './components/PrivateRoute';
import MatchCentreBar from './components/MatchCentreBar';
import AppErrorBoundary from "./components/AppErrorBoundary";
import Menu from './components/Menu';
import FetchUserIfAuthenicated from './components/utils/FetchUserIfAuthenicated';
import SetSelectedLeague from './components/utils/SetSelectedLeague';
import NotificationBar from "./components/NotificationBar";

import IconExample from './pages/IconExamples';
import Home from './pages/Home';

import MyLeagues from './pages/leagues/MyLeagues';
import LeaguesJoin from './pages/leagues/LeaguesJoin';
import LeagueCreate from './pages/leagues/LeagueCreate';

import LeagueOverview from './pages/league/LeagueOverview';
import LeagueFixtures from './pages/league/LeagueFixtures';
import LeagueLadder from './pages/league/LeagueLadder';
import LeagueAbout from './pages/league/LeagueAbout';
import LeagueHistory from './pages/league/LeagueHistory';
import LeagueSettings from './pages/league/LeagueSettings';
import LeagueDraftOrder from './pages/league/LeagueDraftOrder';
import Team from './pages/league/Team';
import Player from './pages/league/Player';
import Players from './pages/league/Players';
import Transacitions from './pages/league/Transacitions';
import PlayersCompare from "./pages/league/PlayersCompare";
import MatchUp from './pages/league/MatchUp';
import PreDraft from './pages/league/PreDraft';
import LiveDraft from './pages/league/LiveDraft';

import Help from './pages/Help';
import MatchCentre from './pages/MatchCentre';
import LeagueInvite from "./pages/league/Invite";

const matchup_url = "/league/:league_id/matchup/:home_team_id/:away_team_id/:round_id";

type Props = {
	setPositions: Function
}
class App extends React.Component<Props> {
	componentDidMount() {
		const { setPositions } = this.props;
		setPositions(positions);
	}

	render() {
		return (
			<AppErrorBoundary>
				<Router basename={process.env.REACT_APP_BASE_URL || ''}>
					<Switch>
						<SSO>
							<Switch>
								<FetchUserIfAuthenicated>
									<Header />
									<NotificationBar />
									<MatchCentreBar />
									<Menu />
									<Route
										path="/league/:league_id"
										component={SetSelectedLeague}
									/>
									<Switch>
										<Route path="/" exact component={Home} />

										<Route path="/icons" exact component={IconExample} />
										<PrivateRoute
											path="/leagues"
											exact
											component={MyLeagues}
										/>
										<PrivateRoute
											path="/leagues/join/:code?"
											exact
											component={LeaguesJoin}
										/>
										<PrivateRoute
											path="/leagues/create/:regenerate_league_id?"
											exact
											component={LeagueCreate}
										/>
										<PrivateRoute
											path="/league/:league_id"
											exact
											component={LeagueOverview}
										/>
										<PrivateRoute
											path="/league/:league_id/about"
											exact
											component={LeagueAbout}
										/>
										<PrivateRoute
											path="/league/:league_id/history"
											exact
											component={LeagueHistory}
										/>
										<PrivateRoute
											path="/league/:league_id/settings"
											exact
											component={LeagueSettings}
										/>
										<PrivateRoute
											path="/league/:league_id/draft-order"
											exact
											component={LeagueDraftOrder}
										/>
										<PrivateRoute
											path="/league/:league_id/team/pre-draft"
											exact
											component={PreDraft} />
										<PrivateRoute
											path="/league/:league_id/team/live-draft"
											exact
											component={LiveDraft} />
										<PrivateRoute
											path="/league/:league_id/team/:team_id?/:round_id?"
											exact
											component={Team}
										/>
										<PrivateRoute
											path="/league/:league_id/players"
											exact
											component={Players}
										/>
										<PrivateRoute
											path="/league/:league_id/transactions"
											exact
											component={Transacitions}
										/>
										<PrivateRoute
											path="/league/:league_id/invite"
											exact
											component={LeagueInvite}
										/>
										<PrivateRoute
											path="/league/:league_id/fixtures"
											exact
											component={LeagueFixtures}
										/>
										<PrivateRoute
											path="/league/:league_id/ladder"
											exact
											component={LeagueLadder}
										/>
										<PrivateRoute
											path="/league/:league_id/players/compare"
											exact
											component={PlayersCompare}
										/>
										<PrivateRoute
											path="/league/:league_id/player/:playerId"
											exact
											component={Player}
										/>
										<PrivateRoute
											path={matchup_url}
											exact
											component={MatchUp}
										/>
										<PrivateRoute
											path="/league/:league_id/matchup"
											exact
											component={MatchUp}
										/>
										<PrivateRoute
											path="/match-centre/:match_id"
											exact
											component={MatchCentre}
										/>
										<Route path="/help" exact component={Help} />
										<Route path="/help/:section" exact component={Help} />
										<Redirect to="/" />
									</Switch>
									<Footer />
								</FetchUserIfAuthenicated>
							</Switch>
						</SSO>
					</Switch>
				</Router>
			</AppErrorBoundary>
		);
	}
};

const mapDispatchToProps = {
	setPositions: actions.positions.setPositions
};

export default connect(null, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js